import { Component, input, signal } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SkillService } from '../../../../services/skill.service';
import { DropdownControl } from '../../../controls/setup-wizard/dropdown-control/dropdown-control';

@Component({
	selector: 'app-skill-code-dropdown-field',
	imports: [DropdownControl],
	standalone: true,
	templateUrl: './skill-code-dropdown-field.html',
	styleUrl: './skill-code-dropdown-field.scss',
})
export class SkillCodeDropdownField {
	label = input.required<string>();
	controlName = input.required<string>();
	placeholder = input<string>('');
	required = input<boolean>(true);
	formGroup = input.required<FormGroup>();
	options = signal<{ value: string; label: string }[]>([]);

	constructor(private skillService: SkillService) {
		this.skillService.getSkills$().then(skills => {
			this.options.set(skills.map(skill => ({ value: skill.code, label: skill.code })));
		});
	}
}
